import { createSlice, PayloadAction } from "@reduxjs/toolkit"
import { IKycFlowDto, IKycOrgDetails, IKycWebshopDetails } from "../types/kyc/kycFlowTypes"
import { SharedStoreState } from "./SharedStoreState"

export interface IKycStoreAddition {
    kyc: IKycSliceState
}

interface IKycSliceState {
    orgDetails: { [organizationId: string]: IKycOrgDetails | undefined }
    webshopDetails: { [webshopId: string]: IKycWebshopDetails | undefined }
    flows: { [organizationId: string]: IKycFlowDto[] | undefined }
}

const initialState: IKycSliceState = {
    orgDetails: {},
    webshopDetails: {},
    flows: {}
}

export const kycSlice = createSlice({
    name: "kyc",
    initialState,
    reducers: {
        orgDetails: (state, action: PayloadAction<{ organizationId: string; details: IKycOrgDetails | undefined }>) => {
            state.orgDetails[action.payload.organizationId] = action.payload.details
        },
        webshopDetails: (state, action: PayloadAction<{ webshopId: string; details: IKycWebshopDetails | undefined }>) => {
            state.webshopDetails[action.payload.webshopId] = action.payload.details
        },
        setFlows: (state, action: PayloadAction<{ organizationId: string; flows: IKycFlowDto[] }>) => {
            state.flows[action.payload.organizationId] = action.payload.flows
        },
    },
})

export const kycActions = kycSlice.actions
export const kycSelectors = {
    orgDetails: (state: SharedStoreState, organizationId: string) => state.kyc.orgDetails[organizationId],
    webshopDetails: (state: SharedStoreState, webshopId: string) => state.kyc.webshopDetails[webshopId],
    flows: (state: SharedStoreState, organizationId: string) => state.kyc.flows[organizationId],
}
